export default __webpack_public_path__ + "static/media/DeleteIcon.e7854057.svg";